module.exports = __webpack_public_path__ + "img/drop-down-icon.e596fda8c9e1b7552c5de18d1a7af098.svg";